import { useLenis } from 'lenis/react';
import { useState } from 'react';

const useScrollThreshold = (threshold: number) => {
  const [afterThreshold, setAfterThreshold] = useState<boolean>(false);

  useLenis((lenis) => {
    setAfterThreshold(lenis.animatedScroll >= threshold);
  });

  return afterThreshold;
};

export default useScrollThreshold;
